import { render } from "./NewsPanel.vue?vue&type=template&id=9389f13e&ts=true"
import script from "./NewsPanel.vue?vue&type=script&lang=ts"
export * from "./NewsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\www\\.dev\\.vue\\n3t.bitbucket.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__